var render, staticRenderFns
import script from "./PanduanValidasi.vue?vue&type=script&lang=js&"
export * from "./PanduanValidasi.vue?vue&type=script&lang=js&"
import style0 from "./PanduanValidasi.vue?vue&type=style&index=0&id=2c51d012&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports